import React from 'react';
import Dropdown from './Dropdown';
import { linkLabel, placeOf, tokenLabel } from './merge';

const labelOf = (listing) => linkLabel(listing) || 'Listing ' + listing.id;

/**
 * The Summit listings a letter markets. They are picked once for every owner,
 * so whatever they leave blank is typed in here, once, too.
 */
export default function ListingPicker({ choices, error, picked, onPick, onRemove, gaps, typed, onType }) {
    const pickedIds = picked.map((listing) => listing.id);
    const options = (choices || []).map((listing) => ({
        key: listing.id,
        primary: (listing.name || '').trim() || 'Listing ' + listing.id,
        secondary: placeOf(listing),
    }));

    // Several listings: one without a Flip Book simply has no line in the list.
    const unlinked = picked.length > 1 ? picked.filter((listing) => !listing.link) : [];

    const placeholder = !choices
        ? (error ? 'Listings could not be loaded' : 'Loading listings…')
        : picked.length ? 'Add another Summit listing' : 'Pick a Summit listing';

    return (
        <div className="mm-field mm-listing">
            <div className="mm-eyebrow">Listings you are marketing</div>
            {error ? <div className="mm-alert--danger">{error}</div> : null}

            <div className="mm-listing__pick">
                <Dropdown
                    value=""
                    placeholder={placeholder}
                    options={options}
                    isOn={(id) => pickedIds.indexOf(id) !== -1}
                    onPick={onPick}
                    multiple
                    ariaLabel="Listings this letter markets"
                    searchPlaceholder="Search by name, city or state"
                    emptyText="No Summit listing matches."
                />
            </div>

            {picked.length ? (
                <div className="mm-listing__chips">
                    {picked.map((listing) => (
                        <span key={listing.id} className="mm-attachment">
                            <span className="mm-attachment__name">{labelOf(listing)}</span>
                            <button
                                className="mm-attachment__remove"
                                title={'Remove ' + labelOf(listing)}
                                aria-label={'Remove ' + labelOf(listing)}
                                onClick={() => onRemove(listing.id)}
                            >
                                &times;
                            </button>
                        </span>
                    ))}
                </div>
            ) : null}

            {unlinked.length ? (
                <div className="mm-listing__note">
                    No Flip Book link on {unlinked.map(labelOf).join(', ')}, so the letter has no link for {unlinked.length === 1 ? 'it' : 'them'}.
                </div>
            ) : null}

            {gaps.length ? (
                <div className="mm-alert--warn mm-listing__gaps">
                    <div>
                        Blank on {picked.length === 1 ? 'this listing' : 'these listings'}: type it once here for every
                        owner, or fill it in on the property.
                    </div>
                    <div className="mm-row__fills">
                        {gaps.map((token) => (
                            <label className="mm-fill" key={token}>
                                <span>{tokenLabel(token)}</span>
                                <input
                                    value={typed[token] || ''}
                                    onChange={(event) => onType(token, event.target.value)}
                                    placeholder={'Type a ' + tokenLabel(token).toLowerCase()}
                                />
                            </label>
                        ))}
                    </div>
                </div>
            ) : null}
        </div>
    );
}
